import React from 'react';
import PropTypes from 'prop-types';
import { Label, StyledValue } from '../../AlertStyles';

const Value = ({ label, children }) => {
  if (!children) {
    return null;
  }
  return (
    <Label>
      {label} <StyledValue>{children}</StyledValue>
    </Label>
  );
};

Value.defaultProps = {
  children: null,
};

Value.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.string,
};

export default Value;
